module.exports = __webpack_public_path__ + "static/media/grow.66ce11d8.mp3";